import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ItemBrand from "../../../containers/modules/master/item-brand";

export default function ItemBrandRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="item-brand"
      index
      element={
        <AccessControl
          name={"Item Brand List"}
          auth={authUser}
          component={() => <ItemBrand authUser={authUser}></ItemBrand>}
        />
      }
    />
  );
}
